import {
  RatingConfigurator,
  MultipleSelectionConfigurator,
  CommentConfigurator,
  EmailConfigurator,
} from '@bingads-webui-campaign-react/survey-factory-tools';

export const AdsStudioAppSurveyConfig = (options) => {
  const { i18n } = options;

  return {
    featureArea: 'AdsStudioAppSurvey',
    style: {
      root: {
        maxWidth: 600,
      },
    },
    others: {
    },
    rating: {
      isRequired: true,
      Type: RatingConfigurator,
      key: 'rating',
      page: 0,
      position: 0,
      getTitle: () => i18n.getString(_TL_('How satisfied are you with Microsoft Advertising\'s Ads Studio?')),
      isVisible: () => true,
      options: [
        {
          key: '5',
          text: i18n.getString(_TL_('Very satisfied')),
          rating: 1.0,
        },
        {
          key: '4',
          text: i18n.getString(_TL_('Moderately satisfied')),
          rating: 0.8,
        },
        {
          key: '3',
          text: i18n.getString(_TL_('Neutral')),
          rating: 0.6,
        },
        {
          key: '2',
          text: i18n.getString(_TL_('Moderately dissatisfied')),
          rating: 0.4,
        },
        {
          key: '1',
          text: i18n.getString(_TL_('Very dissatisfied')),
          rating: 0.2,
        },
      ],
    },
    email: {
      Type: EmailConfigurator,
      key: 'email',
      page: 1,
      position: 2,
      getTitle: () => i18n.getString(_TL_('Can we follow up with you about your responses?')),
      isVisible: answers => ['2', '1'].includes(answers.rating.selectedOption),
      options: [
        {
          key: 'yes',
          text: i18n.getString(_TL_('Yes - specify the contact email below')),
          placeholder: i18n.getString(_TL_('Enter your email')),
          hasInput: true,
        },
        {
          key: 'no',
          text: i18n.getString(_TL_('No')),
        },
      ],
    },
    questions: [
      {
        isRequired: true,
        Type: MultipleSelectionConfigurator,
        key: 'q1',
        page: 0,
        position: 1,
        getTitle: () => i18n.getString(_TL_('Please tell us more about your satisfactory experience with Ads Studio. Select all that apply.')),
        isVisible: () => true,
        options: [
          {
            key: 'q1o1',
            text: i18n.getString(_TL_('The interface is easy to navigate.')),
          },
          {
            key: 'q1o2',
            text: i18n.getString(_TL_('The features and tools are easy to use.')),
          },
          {
            key: 'q1o3',
            text: i18n.getString(_TL_('Editing and managing assets is more efficient.')),
          },
          {
            key: 'q1o4',
            text: i18n.getString(_TL_('Searching for and filtering assets is more effective.')),
          },
          {
            key: 'q1o5',
            text: i18n.getString(_TL_('The loading speed is fast.')),
          },
          {
            key: 'q1o6',
            text: i18n.getString(_TL_('I prefer the Asset Library experience over Ads Studio.')),
          },
          {
            key: 'q1o7',
            text: i18n.getString(_TL_('Other (please elaborate below).')),
          },
        ],
        data: {
        },
      },
      {
        isRequired: true,
        Type: MultipleSelectionConfigurator,
        key: 'q2',
        page: 1,
        position: 0,
        getTitle: () => i18n.getString(_TL_('Please tell us more about why you\'re dissatisfied with Ads Studio. Select all that apply.')),
        isVisible: answers => ['2', '1'].includes(answers.rating.selectedOption),
        options: [
          {
            key: 'q1o1',
            text: i18n.getString(_TL_('Uploading assets could be improved.')),
          },
          {
            key: 'q1o2',
            text: i18n.getString(_TL_('Editing assets could be improved.')),
          },
          {
            key: 'q1o3',
            text: i18n.getString(_TL_('I want more asset types.')),
          },
          {
            key: 'q1o4',
            text: i18n.getString(_TL_('The navigation and interface could be improved.')),
          },
          {
            key: 'q1o5',
            text: i18n.getString(_TL_('Searching for and filtering assets could be improved.')),
          },
          {
            key: 'q1o6',
            text: i18n.getString(_TL_('Ads Studio takes too long to load.')),
          },
          {
            key: 'q1o7',
            text: i18n.getString(_TL_('Other (please elaborate below).')),
          },
        ],
        data: {
        },
      },
      {
        isRequired: false,
        Type: CommentConfigurator,
        key: 'q3',
        page: 1,
        position: 1,
        getTitle: () => i18n.getString(_TL_('How can we continue to improve?')),
        isVisible: answers => ['2', '1'].includes(answers.rating.selectedOption),
        maxLength: 1024,
        data: {
        },
      },
    ],
  };
};
